import React from 'react';
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import OSTotaisGrid from "../../../components/OSTotaisGrid";
import {useSelector} from "react-redux";
import {convertSecondsToHourMinutesFormat, convertSecondsToMinutesSecondsFormat} from "../../../common/Util";
import {CircularProgress} from "@material-ui/core";
import useWindowDimensions from "../../../utils/windowSizeHook";


const useStyles = makeStyles(theme => ({

    gridExterno: {
        display: 'flex',
        flexDirection:'column',
        flexwrap: 'nowrap',
        flexGrow: 3,
        //backgroundColor: 'white',
        margin: '4px',
        // padding: '4px',
        borderRadius: '15px',
        minHeight: '150px',
        width: '120px',
        alignItems: 'center'


    },
    mainGrid: {
        display: 'flex',
        flexDirection:'row',
        flexwrap: 'wrap',
        flexGrow: 12,
        alignItems: 'center',
        justifyContent: 'center'
       // alignSelf: 'stretch',
    },
    operadores: {
        display: 'flex',
        flexDirection:'column',
        flexwrap: 'wrap',
        flexGrow: 12
    },

    gridOSTotais: {
        display: 'flex',
        flexDirection:'column',
        flexwrap: 'nowrap',
        flexGrow: 3,

        margin: 0,
        padding: '4px',
        borderRadius: '15px',
        minHeight: '150px',
        marginBottom:'30px',
        // width: '120px'

    },



}));

const MetasMensalView = () => {

    const classes= useStyles();

    const { height, width } = useWindowDimensions();
    const portrait = height > width;

    const uId =  useSelector(state => state.auth.userId);
    const demo = uId === 268;


    const metaRecapados = useSelector( state => state.i4.metasPeriodo.metaRecapados);
    const recebidosPorData = useSelector( state => state.i4.recebidosPorData);
    let horasTrabalhadas = Number(useSelector( state => state.i4.metasPeriodo.horasTrabalhadas));

    const listaDiasTrabalhados = useSelector( state => state.i4.metasPeriodo.diasTrabalhados);
    const recapadosPorData = useSelector( state => state.i4.recapadosPorData);
    const consertadosPorData = useSelector( state => state.i4.consertadosPorData);
    const recusadosPorData = useSelector( state => state.i4.recusadosPorData);
    const reprovadosPorData = useSelector( state => state.i4.reprovadosPorData);
    const tempoEtapas = useSelector(state => state.ordemServicoReducer.tempoEtapas);
    const periodMax = useSelector( state => state.filter.periodMax );


    console.log("listaDiasTrabalhados", listaDiasTrabalhados);
    let diasTrabalhados = 0;
    if (listaDiasTrabalhados && listaDiasTrabalhados.length > 0) {
      //  console.log("1",periodMax.substr(0,10), (new Date().toISOString().substr(0,10)))
        const dtFimHoje = periodMax.substr(0,10) === (new Date().toISOString().substr(0,10));
        if (dtFimHoje) {
        //    console.log("fimHoje", listaDiasTrabalhados[listaDiasTrabalhados.length-1].data.substr(0,10), (new Date().toISOString().substr(0,10)), listaDiasTrabalhados)
            const ultDiaEhHoje = listaDiasTrabalhados[listaDiasTrabalhados.length-1].data.substr(0,10) === (new Date().toISOString().substr(0,10));
            if (ultDiaEhHoje) {
                diasTrabalhados = ((listaDiasTrabalhados.length - 1) + ((new Date().getHours()) / 24)).toFixed(1);
            } else {
                diasTrabalhados = ((listaDiasTrabalhados.length ) + ((new Date().getHours()) / 24)).toFixed(1);
            }
        } else {
            diasTrabalhados = (listaDiasTrabalhados.length ) ;
        }
    } else {

        if (!demo) {
            return (<CircularProgress/>);
        } else {
            diasTrabalhados = new Date().getDate() - 9;

        }
    }


    //console.log("concluidosPorData", concluidosPorData);



    let recebidos = 0;
    recebidosPorData.map(p => recebidos += p.quantidade);

    let recapados = 0;
    recapadosPorData.map(p => recapados += p.quantidade);

    let consertados = 0;
    consertadosPorData.map(p => consertados += p.quantidade);

    let recusados = 0;
    recusadosPorData.map(p => recusados += p.quantidade);

    let reprovados = 0;
    reprovadosPorData.map(p => reprovados += p.quantidade);




    let totalfabrica = recapados + consertados + recusados + reprovados;
    let percRecap = (totalfabrica > 0)? (recapados*100)/totalfabrica : 0;
    let percCons = (totalfabrica>0)?  (consertados*100)/totalfabrica : 0;


    let tempoProcessamento = 0;
    tempoEtapas
        .filter(e => e.medida === "TODAS MEDIDAS-validos")
        .forEach(p=> tempoProcessamento += Number(p.avgTempoSec) || 0);
    if (demo) {
        tempoProcessamento =  80 * 60;
    }

    let emDesenv=0;

    const diasUteis =  (demo)? 20   :  metaRecapados? (metaRecapados.diasUteis? metaRecapados.diasUteis : 0): 0;
    const pneusPorDia = (demo)? 68   :  (diasTrabalhados > 0)? ( (recapados + consertados) / diasTrabalhados).toFixed(1) : 0;
    const previsaoMes = Math.floor(pneusPorDia *  diasUteis);

    const operadores  =  (demo)? 7.3   : (diasTrabalhados>0)? ((horasTrabalhadas / diasTrabalhados) /8.8).toFixed(1) : 0 ;


   // console.log("asdasdsad", horasTrabalhadas , diasUteis, recapados, operadores);


    if (demo) {
        totalfabrica = pneusPorDia * diasTrabalhados;
        recapados = Math.floor(totalfabrica * 0.96);
        consertados = Math.floor(totalfabrica * 0.04);
        percRecap = (totalfabrica > 0)? (recapados*100)/totalfabrica : 0;
        percCons = (totalfabrica>0)?  (consertados*100)/totalfabrica : 0;
        horasTrabalhadas = 8.8 * diasTrabalhados;
    }

    let pneuPorOperador = (operadores>0)? Math.floor((recapados + consertados) / operadores) : 0;
    const pneuCapacidadePorOperador = (operadores>0)? Math.floor(previsaoMes / operadores) :0;



        return (
            <Grid item container className={classes.gridExterno} xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container item className={classes.mainGrid} xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid item container className={classes.gridOSTotais} xs={3} sm={3} md={6} lg={3} xl={3}>
                        <OSTotaisGrid dados={diasTrabalhados} titulo={"DIAS TRAB."} styleTitulo={ {color: 'green'}} legenda={`de ${diasUteis} dias úteis.` }  />
                    </Grid>

                    <Grid item container className={classes.gridOSTotais} xs={3} sm={3} md={6} lg={3} xl={3}>
                        <OSTotaisGrid dados={pneusPorDia } titulo={"PNEUS POR DIA"} styleTitulo={ {color: 'green'}} legenda={`de ${metaRecapados? (metaRecapados.diasUteis? metaRecapados.diasUteis : 0): 0} dias úteis.` } />
                    </Grid>

                    {/*<Grid item container className={classes.gridOSTotais} xs={3} sm={3} md={3} lg={3} xl={3}>*/}
                    {/*        <OSTotaisGrid dados={recapados} titulo={"RECAPADOS"} styleTitulo={ {color: 'green'}} legenda={"PNEUS"}  />*/}
                    {/*</Grid>*/}
                    {/*<Grid item container className={classes.gridOSTotais} xs={3} sm={3} md={3} lg={3} xl={3}>*/}
                    {/*    <OSTotaisGrid dados={recusados} styleTitulo={ {color: 'red'}} titulo={"RECUSADOS"} legenda={"PNEUS"} />*/}
                    {/*</Grid>*/}

                    <Grid item container className={classes.gridOSTotais} xs={3} sm={3} md={6} lg={3} xl={3}>
                            <OSTotaisGrid dados={tempoProcessamento ? convertSecondsToHourMinutesFormat(tempoProcessamento) : '--'} titulo={"TEMPO PROC"} legenda={"HH:MM / PNEU"}  />
                    </Grid>
                    {/*<Grid item container className={classes.gridOSTotais} xs={3} sm={3} md={3} lg={3} xl={3}>*/}
                    {/*    <OSTotaisGrid dados={recebidos} titulo={"RECEBIDOS"} legenda={"PNEUS"} historico={recebidosPorData} />*/}
                    {/*</Grid>*/}
                    <Grid item container className={classes.gridOSTotais} xs={3} sm={3} md={6} lg={3} xl={3}>
                            <OSTotaisGrid dados={previsaoMes} titulo={"PREVISÃO MÊS"} legenda={"PNEUS"} />
                    </Grid>

                    <Grid item container className={classes.gridOSTotais} xs={3} sm={3} md={6} lg={3} xl={3}>
                        <OSTotaisGrid dados={recapados} titulo={"RECAPADOS"} styleTitulo={ {color: 'green'}} legenda={"PNEUS"} observacao={`${(percRecap).toFixed(1)}% de ${totalfabrica}`}  />
                    </Grid>

                    <Grid item container className={classes.gridOSTotais} xs={3} sm={3} md={6} lg={3} xl={3} >
                        <OSTotaisGrid dados={consertados} titulo={"VULCANIZADOS"} styleTitulo={ {color: 'green'}} legenda={"PNEUS"} observacao={`${(percCons).toFixed(1)}% de ${totalfabrica}`}  />
                    </Grid>

                    <Grid item container className={classes.gridOSTotais} xs={3} sm={3} md={6} lg={3} xl={3}>
                        <OSTotaisGrid dados={operadores} titulo={"OPERADORES"} observacao={`${horasTrabalhadas? horasTrabalhadas.toFixed(1) : '--'} horas`} legenda={`${horasTrabalhadas? horasTrabalhadas.toFixed(1) : '--'} horas / ${diasTrabalhados} dias trabalhados / 8.8 horas/dia  ` } />
                    </Grid>
                    <Grid item container className={classes.gridOSTotais} xs={3} sm={3} md={6} lg={3} xl={3}>
                        <OSTotaisGrid dados={pneuCapacidadePorOperador} titulo={"PREV. PNEUS/OPER."} legenda={'PREVISAO / OPERADORES'} observacao={`ATE HOJE: ${pneuPorOperador }`} />
                    </Grid>
                    {/*<Grid item container className={classes.gridOSTotais} xs={3} sm={3} md={3} lg={3} xl={3}>*/}
                    {/*    <OSTotaisGrid dados={pneuCapacidadePorOperador} titulo={"CAPAC. PNEUS/OPER."} legenda={"PNEUS"} />*/}
                    {/*</Grid>*/}




                </Grid>
            </Grid>



        )
    }

export default MetasMensalView;


